import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import AreaChart from "../../components/AreaCharts";
import { Table } from "react-bootstrap";
import NoDateFound from "../../components/NoDateFound";
import Loader from "../../components/loader/Loader";
import axiosInstance from "../../utils/axiosConfig";
import ViewTrendProduct from "../../components/products/ViewTrendProduct";
import ViewTrendBlog from "../../components/blog/ViewTrendBlog";
import * as CustomToast from "../../components/CustomToastMessage";
import NewUserChart from "./newUserChart/NewUserChart";

function Dashboard() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedBlog, setSelectedBlog] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [showBlogModal, setShowBlogModal] = useState(false);

  const [dashboardStats, setDashboardStats] = useState({
    savedTips: 0,
    activeUsers: 0,
    weeklySubscribers: 0,
    weeklyActiveUsers: 0,
  });
  const [trendingBlogs, setTrendingBlogs] = useState([]);
  const [trendingProducts, setTrendingProducts] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const getDashboardData = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/admin/dashboard/get`
        );
        if (response.data.success) {
          const {
            savedTips,
            activeUsers,
            weeklySubscribers,
            weeklyActiveUsers,
            blogs,
            products,
          } = response.data.data;
          setDashboardStats({
            savedTips,
            activeUsers,
            weeklySubscribers,
            weeklyActiveUsers,
          });
          setTrendingBlogs(blogs);
          setTrendingProducts(products);
        }
      } catch (error) {
        if (error.response.data.status === 400) {
          CustomToast.error(error.response?.data?.message);
        }
        console.error(error.response?.data?.message || "Internal server error");
      } finally {
        setLoading(false);
      }
    };



    getDashboardData();
  }, []);

  const dashboardData = [
    {
      title: "Saved Tips",
      count: dashboardStats.savedTips ? dashboardStats.savedTips : 0,
      image: "/images/png/saved-tips.png",
      alt: "Saved Tips Icon",
    },
    {
      title: "Total Active Users",
      count: dashboardStats.activeUsers ? dashboardStats.activeUsers : 0,
      image: "/images/png/users.png",
      alt: "Users Icon",
    },
    {
      title: "New Weekly Subscribers",
      count: dashboardStats.weeklySubscribers
        ? dashboardStats.weeklySubscribers
        : 0,
      image: "/images/png/subscriber.png",
      alt: "Subscriber Icon",
    },
    {
      title: "New Weekly Users",
      count: dashboardStats.weeklyActiveUsers
        ? dashboardStats.weeklyActiveUsers
        : 0,
      image: "/images/png/active-user.png",
      alt: "Active User Icon",
    },
  ];

  return (
    <Layout title="Dashboard">
      <main>
        <div className="page-card bg-transparent">
          <div className="row dashboard-card g-4">
            {dashboardData.map((item, index) => (
              <div className="col-md-6 col-lg-3" key={index}>
                <div className="card h-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <h4>{item.count}</h4>
                        <p>{item.title}</p>
                      </div>
                      <img
                        src={item.image}
                        width={50}
                        height={50}
                        alt={item.alt}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {loading && <Loader />}
          <NewUserChart />
          <div className="row mt-0 g-4">
            <div className="col-lg-6">
              <div className="card trending-card rounded-4">
                <div className="card-header mx-0 px-4">
                  <h5>Trending Products</h5>
                </div>
                <div className="card-body">
                  <div className="overflow-auto">
                    <Table className="vertical-align">
                      <thead>
                        <tr>
                          <th>Images</th>
                          <th>Title</th>
                        </tr>
                      </thead>
                      <tbody>
                        {trendingProducts.length > 0 ? (
                          trendingProducts.map((product, index) => (
                            <React.Fragment key={product._id}>
                              <tr
                                key={product._id}
                                onClick={() => {
                                  setSelectedProduct(product);
                                  setShowModal(true);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <td width={100}>
                                  <div className="table-border-image">
                                    <img
                                      src={
                                        product.productImage
                                          ? `${process.env.REACT_APP_BACKEND_URL}/${product.productImage[0]}`
                                          : `/images/png/product_sample.png`
                                      }
                                      width={70}
                                      height={70}
                                      className="rounded-3 object-fit-cover"
                                      alt={product.name}
                                    />
                                  </div>
                                </td>
                                <td>{product.name ? product.name : "-"}</td>
                              </tr>
                            </React.Fragment>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="2" className="text-center">
                              <NoDateFound />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card trending-card rounded-4">
                <div className="card-header mx-0 px-4">
                  <h5>Trending Recipe Blogs</h5>
                </div>
                <div className="card-body">
                  <div className="overflow-auto">
                    <Table className="vertical-align">
                      <thead>
                        <tr>
                          <th>Images</th>
                          <th>Title</th>
                        </tr>
                      </thead>
                      <tbody>
                        {trendingBlogs.length > 0 ? (
                          trendingBlogs.map((blog, index) => (
                            <React.Fragment key={blog._id}>
                              <tr
                                key={blog._id}
                                onClick={() => {
                                  setSelectedBlog(blog);
                                  setShowBlogModal(true);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <td width={100}>
                                  <img
                                    // src={
                                    //   blog.blogImage
                                    //     ? `${process.env.REACT_APP_BACKEND_URL}/${blog.blogImage}`
                                    //     : `/images/png/blog_sample.png`
                                    // }
                                    src={
                                      blog?.phoneImage || blog?.blogImage
                                        ? `${
                                            process.env.REACT_APP_BACKEND_URL
                                          }/${
                                            blog?.phoneImage || blog?.blogImage
                                          }`
                                        : "https://img.freepik.com/premium-photo/adult-beautiful-woman-working-out-light-background_470178-19669.jpg"
                                    }
                                    width={70}
                                    height={70}
                                    className="rounded-3 object-fit-cover"
                                    alt={blog.title}
                                  />
                                </td>
                                <td>{blog.title ? blog.title : "-"}</td>
                              </tr>
                            </React.Fragment>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="2" className="text-center">
                              <NoDateFound />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {selectedProduct && (
                      <ViewTrendProduct
                        product={selectedProduct}
                        show={showModal}
                        onHide={() => setShowModal(false)}
                      />
                    )}
                    {selectedBlog && (
                      <ViewTrendBlog
                        blog={selectedBlog}
                        show={showBlogModal}
                        onHide={() => setShowBlogModal(false)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default Dashboard;
